var map = {
	"./icon_permission_chrome.svg": [
		2494,
		32
	],
	"./icon_permission_edge-chromium.svg": [
		2495,
		33
	],
	"./icon_permission_firefox.svg": [
		2496,
		34
	],
	"./icon_permission_safari.svg": [
		2497,
		35
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2270;
module.exports = webpackAsyncContext;